import baseUrl from './baseUrl'

export default {
  action: {
    read: 'read',
    permissionLogin: 'allow',
  },

  resource: {
    auth: 'Auth',
    user: 'partner',
  },

  // BASEURL
  baseUrl: baseUrl.ApiBaseUrl,
  baseUrlV2: baseUrl.ApiBaseUrlV2,
  serverBaseUrl: baseUrl.serverBaseUrl,
  debtiaappUrl: baseUrl.debtiaappUrl,
}
